import { AppConfigStateModel, AuthConfig } from '../../../model';

export class SetConfigs {
  static readonly type = '[Config] SetConfig';
  constructor(public payload: AppConfigStateModel) {}
}

export class SetAuthConfigs {
  static readonly type = '[Config] SetAuth';
  constructor(public payload: AuthConfig) {}
}
